<!-- template html -->
<template>
    <div :id="gt_overlay"  v-show="show" class="modalGTOverlayTemplate" style="left: 50%; top: 50%; transform: translate(-50%,-50%); position: fixed; z-index: 99999999999; display: none; text-align:center; -webkit-transform: translate(-50%, -50%);">
        <div style="min-width:200px; text-align:center;">
            <div style="clear:both;">
                <img id="loadingBar" :src="$getAssetUrlPlugin('siteres/gt-loader.gif')" width="180" />
            </div>
            <div class="progressBar" style="display:none;">
                <div v-show="progressBar" class="progress_bar" style="width:100%; background-Color:#05eaed"></div>
            </div>
        </div>
    </div>
</template>
<!-- template html -->
<!-- script -->
<script>
    export default {
        name: 'GTLoader',
        components: {
        },
        props: {
        },
        data: function () {
            return {
                progressBar: false,
                gt_overlay: "",
                show: false
            }
        },
        mounted: function () {
        },
        methods: {
            showLoadScreen() {
                this.show = true;
                setTimeout(
                    function () {
                        this.progressBar = true;
                        //this.progressBar.style.width = "100%";
                        //this.progressBar.style.backgroundColor = "#05eaed";
                    }
                    , 20);
            },
            hideLoadScreen() {
                this.show = false;
                this.progressBar = false;
            }
        },
        computed: {
        }
    }
</script>
<!-- script -->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modalGTOverlayTemplate {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
        z-index: 1500;
        background-color: rgba(255,255,255,0.95); /* black semi-transparent */
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>